import React from "react";
import ct from "class-types.macro";
import PaginationModel from "../common/Store/models/Pagination";
import Pagination from "~/common/Pagination";

interface Props {
  paging: PaginationModel;
  setCurrentPage?: React.Dispatch<React.SetStateAction<number>>;
  showPagination: boolean;
}

const BrandPagination = ({ paging, setCurrentPage, showPagination }: Props) => {
  return (
    <div
      id="paging"
      data-testid="paging"
      className={ct("clear-both", "p-6", "text-center")}
    >
      {showPagination && (
        <Pagination
          onChange={setCurrentPage}
          currentPage={paging.currentPage}
          total={paging.totalNumberOfItems}
          pageSize={paging.pageSize}
        />
      )}
    </div>
  );
};

export default BrandPagination;
